import { render } from "./Strava.vue?vue&type=template&id=3ad5ec40"
import script from "./Strava.vue?vue&type=script&lang=js"
export * from "./Strava.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__